import { cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { ArticlePromo } from './article-promo.esm.js';

/**
 * @description
 * **A molecule component that returns the composition of a ArticlePromo with a Number*
 *
 * Requires following element props
 * >- articleTitleElement
 * >- categoryBarElement
 * @property {number} **[listNumber]**: prop to add number next to article promo
 * @property {string} **[className]**: optional prop to add additional tailwind classNames
 *
 */
var ArticlePromoWithNumber = function ArticlePromoWithNumber(props) {
  var articleTitleElement = props.articleTitleElement,
    categoryBarElement = props.categoryBarElement,
    articlePromoContainerStyle = props.articlePromoContainerStyle,
    listNumber = props.listNumber,
    className = props.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('flex flex-row gap-8 lg:gap-4', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "font-serif text-[36px] font-bold leading-[45px] tracking-[-0.025em] text-neutral-bold"
  }, listNumber), /*#__PURE__*/React__default.createElement(ArticlePromo, {
    articleTitleElement: articleTitleElement,
    categoryBarElement: categoryBarElement,
    articlePromoContainerStyle: articlePromoContainerStyle
  }));
};

export { ArticlePromoWithNumber };
//# sourceMappingURL=article-promo-with-number.esm.js.map
